import { render } from "./ProductGiftCardSkeleton.vue?vue&type=template&id=8787651e"
import script from "./ProductGiftCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductGiftCardSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__